module.exports = __webpack_public_path__ + "img/FR41639.a6a3a5af.png";